import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Heading = ({ categoryName }) => {
  const { t } = useTranslation();
  return (
    <h2 className='--filter-title'>
      {t('listing:listing.plus.filters.title', { 0: categoryName })}
    </h2>
  );
};

Heading.propTypes = {
  categoryName: PropTypes.string,
};

Heading.defaultProps = {
  categoryName: '...',
};

export default Heading;
